// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Stat/TrendMeasure" (18302:23530). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetStatTrendmeasureContract = {
    component: 'Widget/Stat/TrendMeasure',
    nodeId: '18302:23530',
    section: 'Widget components (shared)',
    composes: [] as readonly ContractComposition[],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: ['label'] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        { note: '5 labels with their own ink or style', count: 10 },
    ] as readonly ContractDisagreement[],
    textStyleIds: [
        'S:904a063356a39dd0d1d4fdd7560157cec5809cea,',
        'S:2321ac1f65c7a5ed182d197231f134ed42287d2d,',
        'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
        'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
        'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
        'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
    ],
    props: {
        balanceTrend: { kind: 'boolean' },
        emphasis: { kind: 'enum', values: ['default', 'muted'] },
        label: { kind: 'slot' },
        labelPosition: { kind: 'enum', values: ['below', 'inline'] },
        showLabel: { kind: 'boolean' },
        showSubvalue: { kind: 'boolean' },
        showTrend: { kind: 'boolean' },
        showUnit: { kind: 'boolean' },
        size: { kind: 'enum', values: ['regular', 'small', 'inline'] },
        subunit: { kind: 'text' },
        subvalue: { kind: 'text' },
        trend: { kind: 'enum', values: ['success', 'critical'] },
        trendDirection: { kind: 'instance_swap' },
        unit: { kind: 'text' },
        value: { kind: 'text' },
    },
    variants: {
        'size=inline, trend=critical, labelPosition=inline, emphasis=default': {
            container: 'gap-xs h-[1.25rem] items-baseline',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs h-[1.25rem] items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.4422rem] h-[0.4422rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490224;18659:498770',
                    width: 8,
                    height: 8,
                    paths: [
                        {
                            d: 'M0.409181 -2.54313e-06H7.07585V6.66667L5.87824 6.6467L5.88822 2.00599L0.818363 7.07585L0 6.25748L5.06986 1.18762L0.409182 1.17764L0.409181 -2.54313e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                unit: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                caption: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [],
        },
        'size=inline, trend=critical, labelPosition=inline, emphasis=muted': {
            container: 'gap-xs h-[1.25rem] items-baseline',
            label: 'text-content-muted text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs h-[1.25rem] items-baseline',
                'value': 'text-content-muted text-left',
                'unit': 'text-content-muted text-left',
                'Vector': 'w-[0.4422rem] h-[0.4422rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490235;18659:498770',
                    width: 8,
                    height: 8,
                    paths: [
                        {
                            d: 'M0.409181 -2.54313e-06H7.07585V6.66667L5.87824 6.6467L5.88822 2.00599L0.818363 7.07585L0 6.25748L5.06986 1.18762L0.409182 1.17764L0.409181 -2.54313e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                unit: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                caption: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [],
        },
        'size=inline, trend=success, labelPosition=inline, emphasis=default': {
            container: 'gap-xs h-[1.25rem] items-baseline',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs h-[1.25rem] items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.4422rem] h-[0.4422rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490192;18659:498770',
                    width: 8,
                    height: 8,
                    paths: [
                        {
                            d: 'M0.409181 -2.54313e-06H7.07585V6.66667L5.87824 6.6467L5.88822 2.00599L0.818363 7.07585L0 6.25748L5.06986 1.18762L0.409182 1.17764L0.409181 -2.54313e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                unit: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                caption: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [],
        },
        'size=inline, trend=success, labelPosition=inline, emphasis=muted': {
            container: 'gap-xs h-[1.25rem] items-baseline',
            label: 'text-content-muted text-left',
            icon: 'text-status-success',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs h-[1.25rem] items-baseline',
                'value': 'text-content-muted text-left',
                'unit': 'text-content-muted text-left',
                'Vector': 'w-[0.4422rem] h-[0.4422rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490203;18659:498770',
                    width: 8,
                    height: 8,
                    paths: [
                        {
                            d: 'M0.409181 -2.54313e-06H7.07585V6.66667L5.87824 6.6467L5.88822 2.00599L0.818363 7.07585L0 6.25748L5.06986 1.18762L0.409182 1.17764L0.409181 -2.54313e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                unit: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
                caption: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [],
        },
        'size=regular, trend=critical, labelPosition=below, emphasis=default': {
            container: 'gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'Vector': 'w-[0.6634rem] h-[0.6634rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18302:23501;18659:498770',
                    width: 11,
                    height: 11,
                    paths: [
                        {
                            d: 'M0.613772 -3.8147e-06H10.6138V10L8.81737 9.97006L8.83234 3.00898L1.22755 10.6138L0 9.38622L7.60479 1.78143L0.613772 1.76646L0.613772 -3.8147e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:904a063356a39dd0d1d4fdd7560157cec5809cea,',
                unit: 'S:2321ac1f65c7a5ed182d197231f134ed42287d2d,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'size=regular, trend=success, labelPosition=below, emphasis=default': {
            container: 'gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-muted text-left',
                'Vector': 'w-[0.6634rem] h-[0.6634rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18302:23490;18659:498770',
                    width: 11,
                    height: 11,
                    paths: [
                        {
                            d: 'M0.613772 -3.8147e-06H10.6138V10L8.81737 9.97006L8.83234 3.00898L1.22755 10.6138L0 9.38622L7.60479 1.78143L0.613772 1.76646L0.613772 -3.8147e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:904a063356a39dd0d1d4fdd7560157cec5809cea,',
                unit: 'S:2321ac1f65c7a5ed182d197231f134ed42287d2d,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, trend=critical, labelPosition=below, emphasis=default': {
            container: 'gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.5528rem] h-[0.5528rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18302:23523;18659:498770',
                    width: 9,
                    height: 9,
                    paths: [
                        {
                            d: 'M0.511477 -3.17891e-06H8.84481V8.33333L7.34781 8.30838L7.36028 2.50748L1.02295 8.84481L0 7.82185L6.33733 1.48453L0.511477 1.47205L0.511477 -3.17891e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
                unit: 'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, trend=critical, labelPosition=inline, emphasis=default': {
            container: 'gap-xs items-baseline',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.5528rem] h-[0.5528rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490214;18659:498770',
                    width: 9,
                    height: 9,
                    paths: [
                        {
                            d: 'M0.511477 -3.17891e-06H8.84481V8.33333L7.34781 8.30838L7.36028 2.50748L1.02295 8.84481L0 7.82185L6.33733 1.48453L0.511477 1.47205L0.511477 -3.17891e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
                unit: 'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, trend=success, labelPosition=below, emphasis=default': {
            container: 'gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.5528rem] h-[0.5528rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18302:23512;18659:498770',
                    width: 9,
                    height: 9,
                    paths: [
                        {
                            d: 'M0.511477 -3.17891e-06H8.84481V8.33333L7.34781 8.30838L7.36028 2.50748L1.02295 8.84481L0 7.82185L6.33733 1.48453L0.511477 1.47205L0.511477 -3.17891e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
                unit: 'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, trend=success, labelPosition=inline, emphasis=default': {
            container: 'gap-xs items-baseline',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'value-row': 'gap-xs items-baseline',
                'value': 'text-content-default text-left',
                'unit': 'text-content-default text-left',
                'Vector': 'w-[0.5528rem] h-[0.5528rem]',
                'label': 'gap-xs items-start',
                'caption': 'text-content-muted text-left',
            },
            glyphs: {
                Vector: {
                    name: 'Vector',
                    nodeId: 'I18633:490182;18659:498770',
                    width: 9,
                    height: 9,
                    paths: [
                        {
                            d: 'M0.511477 -3.17891e-06H8.84481V8.33333L7.34781 8.30838L7.36028 2.50748L1.02295 8.84481L0 7.82185L6.33733 1.48453L0.511477 1.47205L0.511477 -3.17891e-06Z',
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {
                value: 'S:3b8ed0d6061e807aeed3f3ac94251a119a3d68ec,',
                unit: 'S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,',
                caption: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
